import React from "react";

interface Props {
  /** True when an empty result is due to an active search filter. */
  filtered: boolean;
  onNewMindmap: () => void;
}

export const EmptyState: React.FC<Props> = ({ filtered, onNewMindmap }) => {
  return (
    <div
      data-testid="my-files-empty-state"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "50vh",
        gap: "0.75rem",
        padding: "2rem",
        color: "var(--mf-text)",
      }}
    >
      {filtered ? (
        <>
          <h2 style={{ margin: 0, fontSize: "1.15rem" }}>
            No mindmaps match your search
          </h2>
          <p style={{ color: "var(--mf-text-muted)", maxWidth: "22rem" }}>
            Try a different title, or clear the search to see all your files.
          </p>
        </>
      ) : (
        <>
          <h2 style={{ margin: 0, fontSize: "1.25rem" }}>No mindmaps yet</h2>
          <p style={{ color: "var(--mf-text-muted)", maxWidth: "22rem" }}>
            Save your first mindmap to the cloud and it will show up here.
          </p>
          <button
            type="button"
            onClick={onNewMindmap}
            style={{
              marginTop: "0.5rem",
              background: "var(--mf-accent)",
              color: "var(--mf-accent-text)",
              padding: "0.65rem 1.25rem",
              borderRadius: "0.375rem",
              fontSize: "0.9rem",
              fontWeight: 600,
              border: "none",
              cursor: "pointer",
            }}
          >
            New mindmap
          </button>
        </>
      )}
    </div>
  );
};

export default EmptyState;
